export class PlayerFilter {
    filterType: number;
    filterCondition: number;
    filterValue: number | undefined;
    filterStrValue: number | undefined;
    label: string | undefined;
}